import React from 'react';

// Special component for Enterprise device to show cluster visualization
const EnterpriseDeviceCluster = () => {
  return (
    <div className="device-container enterprise-container">
      {/* Main device */}
      <div className="device main-device">
        <div className="device-signal">
          <div className="signal-wave"></div>
          <div className="signal-wave"></div>
          <div className="signal-wave"></div>
        </div>
        <div className="device-screen"></div>
        <div className="device-logo">AEROFI</div>
        <div className="device-button"></div>
      </div>
      
      
      {/* Connection lines between devices */}
      <div className="device-connections">
        {[...Array(5)].map((_, index) => (
          <div 
            key={index} 
            className="connection-line"
            style={{
              width: `${40 + (index * 10)}px`,
              transform: `rotate(${-30 + (index * 15)}deg)`,
              opacity: 0.6 - (index * 0.1)
            }}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default EnterpriseDeviceCluster;
